var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataIndex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u9884\u7EA6\u5907\u4EFD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u4F1A\\u6240\\u7BA1\\u7406",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6253\\u4F4D\\u7BA1\\u7406",
    transform: "translate(-1337.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u798F\\u5229\\u6A21\\u5757\\u5907\\u4EFD-3",
    transform: "translate(232.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-8",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E00\\u53F7\\u6253\\u4F4D\\u5907\\u4EFD-6",
    transform: "translate(966.400000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Dropdown/Light/Option",
    transform: "translate(125.800000, 46.009249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6570\\u636E",
    transform: "translate(13.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0833333,2 L2.91666667,2 C2.41040694,2 2,2.37309722 2,2.83333333 L2,11.1666667 C2,11.6269167 2.41040694,12 2.91666667,12 L12.0833333,12 C12.5896083,12 13,11.6269167 13,11.1666667 L13,2.83333333 C13,2.37309722 12.5896083,2 12.0833333,2 Z",
    id: "\\u8DEF\\u5F84",
    strokeOpacity: 0.85,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    strokeOpacity: 0.85,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "5 8.10000015 6.8666668 6.23333335 7.8000002 7.8666668 9.666667 6"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIndex);
export default __webpack_public_path__ + "static/media/data-index.dbfb894b552128009a8584aaaaf65c82.svg";
export { ForwardRef as ReactComponent };